import React, { useState, useEffect } from "react";
import "../Css/NewC.css";

const getStorageTheme = () => {
  let theme = "light-theme";
  if (localStorage.getItem("theme")) {
    theme = localStorage.getItem("theme");
  }
  return theme;
};

const Follower = ({ username, user, photoURL }) => {
  const [theme, setTheme] = useState(getStorageTheme());

  const toggleTheme = () => {
    if (theme === "light-theme") {
      setTheme("dark-theme");
    } else {
      setTheme("light-theme");
    }
  };

  useEffect(() => {
    document.documentElement.className = theme;
    localStorage.setItem("theme", theme);
  }, [theme]);
  return (
    <div className="container">
      <button className="btn" onClick={toggleTheme}>
        toggle
      </button>
      <article className="card">
        <img src={user?.photoURL} alt="new" />
        <h4>{user.displayName}</h4>
        <a href="#" className="btn">
          view profile
        </a>
      </article>

      <article className="card">
        <img src={user?.photoURL} alt="new" />
        <h4>{user?.displayName}</h4>
        <a href="#" className="btn">
          view profile
        </a>
      </article>

      <article className="card">
        <img src={user?.photoURL} alt="new" />
        <h4>{user?.displayName}</h4>
        <a href="#" className="btn">
          view profile
        </a>
      </article>

      <article className="card">
        <img src={user?.photoURL} alt="new" />
        <h4>{user?.displayName}</h4>
        <a href="#" className="btn">
          view profile
        </a>
      </article>

      <article className="card">
        <img src={user?.photoURL} alt="new" />
        <h4>{user?.displayName}</h4>
        <a href="#" className="btn">
          view profile
        </a>
      </article>

      <article className="card">
        <img src={user?.photoURL} alt="new" />
        <h4>{user?.displayName}</h4>
        <a href="#" className="btn">
          view profile
        </a>
      </article>

      <article className="card">
        <img src={user?.photoURL} alt="new" />
        <h4>{user?.displayName}</h4>
        <a href="#" className="btn">
          view profile
        </a>
      </article>

      <article className="card">
        <img src={user?.photoURL} alt="new" />
        <h4>{user?.displayName}</h4>
        <a href="#" className="btn">
          view profile
        </a>
      </article>

      <article className="card">
        <img src={user?.photoURL} alt="new" />
        <h4>{user?.displayName}</h4>
        <a href="#" className="btn">
          view profile
        </a>
      </article>
    </div>
  );
};

export default Follower;
